export const version = "networks/5.5.2";
